import invoke from 'lodash/invoke';
import padStart from 'lodash/padStart';
import range from 'lodash/range';
import uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {injectIntl} from 'react-intl';

import messages from './messages';
import {DurationPicker, Inner, Field, Label} from './styles';

import {FormattedMessage} from 'components/FormattedComponents';
import {FormSelectDesktop, FormSelectMobile} from 'components/FormSelect';

@injectIntl
class DurationPickerBase extends Component {
  static propTypes = {
    device: PropTypes.oneOf(['desktop', 'mobile']).isRequired,
    onChange: PropTypes.func
  };

  hoursId = uniqueId('DurationPicker-hours-');
  minutesId = uniqueId('DurationPicker-minutes-');

  hours = '00';
  minutes = '00';
  seconds = '00';

  createChangeHandler = field => fieldValue => {
    this[field] = padStart(fieldValue, 2, '0');

    const composedValue = [this.hours, this.minutes, this.seconds].join(':');
    invoke(this.props, 'onChange', composedValue);
  };

  renderOptions = (start, end) => {
    const {
      intl: {formatMessage}
    } = this.props;

    return [
      <option key="placeholder" value="">
        {formatMessage(messages.formValue_select)}
      </option>,
      ...range(start, end + 1).map(value => (
        <option key={value} value={value}>
          {value}
        </option>
      ))
    ];
  };

  render() {
    const {device} = this.props;

    const FormSelect = device === 'desktop' ? FormSelectDesktop : FormSelectMobile;

    return (
      <DurationPicker>
        <Inner>
          <Field device={device}>
            <FormSelect inputId={this.hoursId} onChange={this.createChangeHandler('hours')}>
              {this.renderOptions(0, 23)}
            </FormSelect>
            <Label htmlFor={this.hoursId}>
              <FormattedMessage {...messages.formField_DurationPicker_hours} />
            </Label>
          </Field>
          <Field device={device}>
            <FormSelect inputId={this.minutesId} onChange={this.createChangeHandler('minutes')}>
              {this.renderOptions(0, 59)}
            </FormSelect>
            <Label htmlFor={this.minutesId}>
              <FormattedMessage {...messages.formField_DurationPicker_minutes} />
            </Label>
          </Field>
        </Inner>
      </DurationPicker>
    );
  }
}

export {DurationPickerBase as DurationPicker};

export const DurationPickerDesktop = props => <DurationPickerBase device="desktop" {...props} />;

export const DurationPickerMobile = props => <DurationPickerBase device="mobile" {...props} />;
